export default function SettingsPage() {
  return (
    <div className="flex flex-col flex-1 overflow-hidden">
      {/* Page header */}
      <div className="shrink-0 bg-white border-b border-gray-200 px-6 py-4">
        <h2 className="text-lg font-semibold text-gray-900">Settings</h2>
        <p className="text-sm text-gray-500 mt-0.5">Account and notification preferences</p>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-6">
        <div className="max-w-2xl space-y-5">
          {/* Company details */}
          <div className="bg-white rounded-xl border border-gray-200 p-6">
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Company Details</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Company Name</label>
                <input
                  type="text"
                  disabled
                  placeholder="Configured by administrator"
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm bg-gray-50 text-gray-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Contact Email</label>
                <input
                  type="email"
                  disabled
                  placeholder="Configured by administrator"
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm bg-gray-50 text-gray-500"
                />
              </div>
            </div>
          </div>

          {/* Notifications */}
          <div className="bg-white rounded-xl border border-gray-200 p-6">
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Notifications</h3>
            <div className="space-y-3">
              {[
                { label: "Transfer downloaded by vessel", defaultChecked: true },
                { label: "New vessel message received", defaultChecked: true },
                { label: "Transfer link expired", defaultChecked: false },
              ].map(({ label, defaultChecked }) => (
                <label key={label} className="flex items-center gap-3 text-sm text-gray-700 cursor-pointer">
                  <input
                    type="checkbox"
                    defaultChecked={defaultChecked}
                    className="h-4 w-4 rounded border-gray-300 accent-navy-700"
                  />
                  {label}
                </label>
              ))}
            </div>
          </div>

          {/* Coming soon */}
          <p className="text-xs text-gray-400 text-center">
            Additional settings will be available in a future release.
          </p>
        </div>
      </div>
    </div>
  );
}
